export default {
    bulkSms: {
        title: `New Text`,
        to: `To:`,
        send: `Send Now`,
        search: `Search for contacts...`,
        placeholder: `Start typing your text...`,
        linkPhoto: `Link to Photo or File`,
        shortenUrl: `Shorten a URL`,
        charactersRemaining: `%{count} Characters remaining`,
        change: `change`,
        options: {
            sendNow: `Send Now`,
            sendCustom: `Send on custom date and time`,
            sendTomorrow3: `Send tomorrow at 3pm`,
            sendTomorrow9: `Send tomorrow at 9am`,
            sendIn6: `Send in 6 hours`,
            am: `AM`,
            pm: `PM`
        },
        instructions: `When linking to a photo or file, Breeze uses a URL shortener to give you more space to type your message`,
        textRemain: `%{count} Texts Remain this Month`,
        searching: `Searching...`,
        searchContacts: `Search for contacts...`,
        noNumber: `No mobile number`,
        alreadyRecipient: `Already a recipient`,
        loadingContacts: `Loading contacts...`,
        success: `Text sent successfully!`,
        date: `Date`,
        time: `Time`,
        validation: {
            mustHaveAtleast: `Must have atleast 1 recipient.`,
            recipientsRequired: `Recipients are required.`,
            messageRequired: `Message is required.`
        },
        error: `Error sending text. Please try again later.`
    },
    enrollTooltip: {
        optIn: `This number has opted-in to receive text messages from your organization.`,
        blocked: `This number has blocked your organization from sending text messages to them.`,
        enroll: `Enroll this number so they can receive text messages from your organization.`
    },
    addFamilyMember: {
        title: `Add Family Member`,
        options: {
            newPerson: {
                title: `New Person`,
                description: `Add a new person to the database as a member of this family.`
            },
            existingPerson: {
                title: `Existing Person`,
                description: `Select a person already in the database to associate as a family member.`
            }
        },
        cancel: `Cancel`
    },
    addFamilyMemberSearch: {
        title: `Add Family Member`,
        personNotFound: 'Person Not Found',
        selectDifferent: 'Select a different person',
        addFamilyMember: 'Add Family Member',
        cancel: `Cancel`
    },
    displayFields: {
        title: `Display Fields`,
        instructions: `Select the profile fields you'd like to include when adding new people. These preferences will be saved for your user. In order to add additional field options, you will need to add a custom field in the Profile Fields section.`
    },
    exportPeopleModal: {
        title: `Export People`,
        download: `Download`,
        cancel: `Cancel`,
        confirmText: ``,
        successUpdate: `Updated people successfully`,
        errorUpdate: `Failed to update people.`
    },
    bulkUpdateModal: {
        title: `Bulk Update People`,
        subtitle: `This action will update all selected profiles with the information provided below.`,
        header: `Applies to:`,
        subHeader: `1 person | %{peopleCount} people`,
        subHeaderContent: `selected from your list`,
        confirmText: `Update`,
        successUpdate: `Updated people successfully`,
        errorUpdate: `Failed to update people.`,
        setByGraduationYear: `Set by Graduation Year`,
        setByGrade: `Set by Grade`
    },
    bulkArchiveModal: {
        title: `Bulk Archive People`,
        personConfirmButton: `Archive 1 Person`,
        peopleConfirmButton: `Archive %{peopleCount} People`,
        confirmText: `Archiving people will remove them from the main People page, general search results, and family member profiles. All of their information will be maintained and accessible. This action can be undone.
        Applies to: %{peopleCount} person selected from your list`,
        successArchive: `Archived people successfully`,
        errorArchive: `Failed to archive people.`
    },
    archiveModal: {
        title: `Archive Person`,
        titleUnarchive: `Unarchive Person`,
        confirmButton: `Archive`,
        confirmButtonUnarchive: `Unarchive`,
        learnMore: `Learn More`,
        cancel: `Cancel`,
        confirmText: `Do you really want to archive this person?`,
        confirmTextUnarchive: `Do you really want to unarchive this person?`,
        successArchive: `Archived person successfully`,
        successUnarchive: `Unarchived person successfully`,
        errorArchive: `Failed to archive person.`,
        errorUnarchive: `Failed to unarchive person.`
    },
    bulkUnarchiveModal: {
        title: `Bulk Unarchive People`,
        personConfirmButton: `Unarchive 1 Person`,
        peopleConfirmButton: `Unarchive %{peopleCount} People`,
        confirmText: `Unarchiving people will add them back into the main People page, general search results, family member profiles, and the Tags they were in before being archived.
        Applies to: %{peopleCount} person selected from your list`,
        successArchive: `Unarchived people successfully`,
        errorArchive: `Failed to unarchive people.`
    },
    bulkDeleteModal: {
        onConfirmError: `An error occurred while deleting people.`,
        onConfirmSuccess: `Person deleted successfully.`,
        title: `Bulk Delete People`,
        content: `We are no longer allowing delete from a member profile as this action is not recommended. Therefore, the profile will be moved to Archive. If you wish to fully delete the record, please select the delete option from the Archive page.`,
        recordsWarning: `Please note deleted records cannot be restored.`,
        recordsWarningDelete: `Contributions records for these people will be marked as anonymous.`,
        recordsWarningPartTwo: `In total, this 1 person has | In total, these %{peopleCount} people have`,
        recordsWarningPartThree: `1 giving record | %{givingCount} giving records`,
        givingRecords: `giving records`,
        confirmButton: `Archive | Archive %{peopleCount} People`,
        confirmButtonDelete: `Delete | Delete %{peopleCount} People`,
        header: `Applies to:`,
        subHeader: `1 person | %{peopleCount} people`,
        subHeaderContent: `selected from your list`,
        warning: `Deleting people will remove them and all of their information from Breeze. This action can be undone for 30 days.`
    },
    bulkAssignToTagsModal: {
        title: `Assign to Tags`,
        subtitle: `This action will add individuals to selected Tags.`,
        confirmButton: `Assign`,
        header: `Applies to:`,
        secondHeader: `Tag Selection:`,
        subHeader: `1 person | %{peopleCount} people`,
        subHeaderContent: `selected from your list`,
        successUpdate: `People Assigned to tags successfully`,
        errorUpdate: `Failed to assign people to tags.`
    },
    person: {
        noInfo: `No information stored.`,
        noContactInfoAvailable: `No contact information available.`,
        familyRole: {
            unassigned: `Unassigned`,
            child: `Child`,
            adult: `Adult`,
            headOfHousehold: `Head of Household`,
            spouse: `Spouse`
        },
        clickToEditSection: `click to edit this section`,
        save: `Save`,
        cancel: `Cancel`,
        phoneInput: {
            showMore: `Show More Options`,
            showFewer: `Show Fewer Options`,
            doNotText: `Do Not Text`,
            makePrivate: `Make Private`,
            private: `Private`
        },
        addressInput: {
            showMore: `Show More Options`,
            showFewer: `Show Fewer Options`,
            applyAddressToAll: `Apply address changes to all family members`,
            makePrivate: `Make Private`,
            private: `Private`
        },
        emailInput: {
            showMore: `Show More Options`,
            showFewer: `Show Fewer Options`,
            doNotEmail: `Do Not Email`,
            makePrivate: `Make Private`,
            private: `Private`
        },
        gradeInput: {
            setByGraduationYear: `Set by Graduation Year`,
            setByGrade: `Set by Grade`,
            grade: `Grade`,
            graduationYear: `Graduation Year`
        }
    }
}
